/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Switch from 'react-switch';
import { toast } from 'react-hot-toast';
import { loaderActions } from '../../../features/Loader/LoaderSlice';
import API from '../../../Services/API';

function VendorForm(props) {
  const [vendor, setVendor] = useState({});

  const dispatch = useDispatch();

  const VendorTypeOptions = [
    {
      value: 'Supplier',
      label: 'Supplier'
    },
    {
      value: 'Warehouse',
      label: 'Warehouse'
    },
    {
      value: 'Hybrid',
      label: 'Hybrid'
    }
  ];

  const shippingMethodOptions = [
    {
      label: 'SeaRailAir',
      value: 'SeaRailAir'
    },
    {
      label: 'Truck',
      value: 'TruckFreight'
    }
  ];
  const animatedComponents = makeAnimated();

  useEffect(() => {
    if (props.vendor.vpFreightType === 'Truck') {
      props.vendor.vpFreightType = 'TruckFreight';
    }
    setVendor(props.vendor);
  }, [props]);

  async function updateVendor() {
    await dispatch(loaderActions.show());
    try {
      await API().patch('/vendor', {
        vendNo: vendor.vendNo,
        data: {
          vendName: vendor.vendName,
          VendorType: vendor.VendorType,
          vpFreightType: vendor.vpFreightType,
          emailAddress: vendor.emailAddress,
          emailAddressCC: vendor.emailAddressCC,
          enableVendorPortal: vendor.enableVendorPortal
        }
      });
      toast.success('Vendor updated successfully.');
      props.onHide('reload');
    } catch (err) {
      toast.error(err.response.data);
    } finally {
      await dispatch(loaderActions.hide());
    }
  }

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        Edit{' '}
        <b>
          &nbsp;{vendor.companyBadgeText}&nbsp;{vendor.vendNo}
        </b>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <Form.Group controlId="vendNum">
              <Form.Label>Vendor #</Form.Label>
              <Form.Control type="text" value={vendor.vendNo} readOnly={true} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="company">
              <Form.Label>Company Badge</Form.Label>
              <Form.Control type="text" value={vendor.companyBadgeText} readOnly={true} />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group controlId="name">
          <Form.Label>Vendor Name</Form.Label>
          <Form.Control
            type="text"
            value={vendor.vendName}
            onChange={(e) => {
              setVendor({ ...vendor, vendName: e.target.value });
            }}
          />
        </Form.Group>

        <Form.Group controlId="VendorType">
          <Form.Label>Vendor Type</Form.Label>
          <Select
            components={animatedComponents}
            options={VendorTypeOptions}
            value={VendorTypeOptions.find((option) => vendor.VendorType === option.value)}
            onChange={(e) => {
              setVendor({ ...vendor, VendorType: e.value });
            }}
          />
        </Form.Group>

        {['Supplier', 'Hybrid'].includes(vendor.VendorType) ? (
          <Form.Group controlId="shippingMethod">
            <Form.Label>Prefer Shipping Method</Form.Label>
            <Select
              components={animatedComponents}
              options={shippingMethodOptions}
              value={shippingMethodOptions.find((option) => vendor.vpFreightType === option.value)}
              onChange={(e) => {
                setVendor({ ...vendor, vpFreightType: e.value });
              }}
            />
          </Form.Group>
        ) : (
          <></>
        )}
        <Form.Group controlId="email">
          <Form.Label>Assigned Email's</Form.Label>
          <Form.Control
            type="text"
            value={vendor.emailAddress}
            placeholder="Assigned Email Addresses"
            onChange={(e) => {
              setVendor({ ...vendor, emailAddress: e.target.value });
            }}
          />
          <Form.Text className="text-muted">
            For multiple email addresses, separate them with a comma.
          </Form.Text>
        </Form.Group>

        <Form.Group controlId="email-cc">
          <Form.Label>CC Email's</Form.Label>
          <Form.Control
            type="text"
            value={vendor.emailAddressCC}
            placeholder="CC Email Addresses"
            onChange={(e) => {
              setVendor({ ...vendor, emailAddressCC: e.target.value });
            }}
          />
          <Form.Text className="text-muted">
            For multiple email addresses, separate them with a comma.
          </Form.Text>
        </Form.Group>

        <Form.Group controlId="enableVendorPortal">
          <Form.Label>Access to EVP</Form.Label>
          <br />
          <Switch
            checked={vendor.enableVendorPortal || false}
            onChange={(checked) => setVendor({ ...vendor, enableVendorPortal: checked })}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-primary" onClick={updateVendor}>
          Update Vendor
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default VendorForm;
